import { Component } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MyharrellsService } from '../myharrells.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import e from 'express';

@Component({
  selector: 'app-myharrellslogin',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './myharrellslogin.component.html',
  styleUrl: './myharrellslogin.component.css'
})
export class MyharrellsloginComponent {

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Login/";

  password: string = "";
  email: string = "";
  displayLoginFailure: boolean = false;
  displayPasswordResetEmailPrompt: boolean = false;
  resetEmail: string = "";
  failureText: string = "";

  displaySuccessAlert: boolean = false;
  successText: string = "";




  constructor(public dotComService: Dotcom2024Service, public myHarrellsService: MyharrellsService, public router: Router, public route: ActivatedRoute) { }

  ngOnInit(): void {
    //if user is logged in pass them through to the myharrells page

    //check if sessionstorage is defined loggedInMyHarrellsUser
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('loggedInMyHarrellsUser')) {
      let loggedInUser = JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser'));
      if (loggedInUser != null) {
        this.myHarrellsService.loggedInMyHarrellsUser = loggedInUser;

        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/myharrells']);
        })
      }
    }

  }


  SubmitClicked() {
    this.myHarrellsService.Login(this.email, this.password).subscribe((data: any) => {
      if (data[0].Name == "failed login" || data[0].Id == null || data[0].Deleted == true) {
        this.failureText = "Login Failed! Please check your entries and try again.  If you have not yet registered, please do so by clicking the 'Account Setup' button.";
        this.displayLoginFailure = true;
      }
      else {
        //passed login - check to see if they are in the middle of the registration process
        if (data[0].LastRegistrationStatus == 'Customer Info Complete' && data[0].Active == false && data[0].Deleted == false) {
          //user is waiting on rep approval
          this.myHarrellsService.loggedInMyHarrellsUser = data[0];
          // this.myHarrellsService.stage == 'CustomerInfo';
          sessionStorage.setItem('loginStage', 'ProcessingRequest');
          this.router.navigate(['/myharrellsaccountsetup']);
        }
        else if (data[0].LastRegistrationStatus == 'Personal Info Complete' && data[0].Active == false && data[0].Deleted == false) {
          //user finished their personal info but did not do the customer registration part of the process
          //fill the registration page with their info so they can complete the process
          this.myHarrellsService.loggedInMyHarrellsUser = data[0];
          // this.myHarrellsService.stage == 'ProcessingRequest';
          sessionStorage.setItem('loginStage', 'CustomerInfo');
          this.router.navigate(['/myharrellsaccountsetup']);
        }
        else {
          if (this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin != null && this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin != 0) {
            //user got to the login by selecting a course from the education section that required a login first 
            //now that they have logged in, take them to the matrix course 
            this.myHarrellsService.loggedInMyHarrellsUser = data[0];
            sessionStorage.setItem('loggedInMyHarrellsUser', JSON.stringify(data[0]));
            this.router.navigate(['/matrix']); 

            // setTimeout(() => {
            //   //now that the control was taken to the matrix page IN A NEW TAB, we can reset this pages 
            //   //location tp the education page - DONT TAKE OUT THE TIMEOUT
            //   window.location.href = '/education';
            // }, 2000);

          }
          else{
            //continute on to my harrells section of the site
            this.myHarrellsService.loggedInMyHarrellsUser = data[0];
            sessionStorage.setItem('loggedInMyHarrellsUser', JSON.stringify(data[0]));
            this.router.navigate(['/myharrells']);            
          }
        }
      }
    })
  }

  CreateAccount(){
    this.router.navigate(['/myharrellsaccountsetup']);
  }

  ResetPassword() {
    this.displayPasswordResetEmailPrompt = true;
  }

  SubmitPasswordResetEmailClicked() {

    if (this.resetEmail.indexOf('.') == -1 || this.resetEmail.indexOf('@') == -1) {
      this.failureText = "Email provided does not seem to be valid. Please check your entries and try again.";
      this.displayLoginFailure = true;
    }
    else {
      this.myHarrellsService.SendPasswordResetEmail(this.resetEmail).subscribe((data: any) => {
        if (data != "failed") {
          this.displayPasswordResetEmailPrompt = false;
          this.successText = "Success! Your email has been sent. Please check your inbox for the instructions to reset your password. Note: it may take a few minutes to receive your email based on your email provider's responsiveness.";
          this.displaySuccessAlert = true;
        }
        else {
          this.failureText = "Password Reset Failed! Please check the email address entered.  It must be the email you have in our system.";
          this.displayLoginFailure = true;
        }
      })
    }
  }

  CancelResetClicked() {
    this.resetEmail = "";
    this.displayPasswordResetEmailPrompt = false;
  }

  HideLoginFailure() {
    this.displayLoginFailure = false;
  }

  HideSuccessAlert() {
    this.displaySuccessAlert = false;
  }

}
